<template>
  <modern-upload-field
    :label="label"
    :name="name"
    :value="value"
    accept=".mp3,audio/*"
    :required="required"
    :uploading="uploading"
    :has-error="hasError"
    :error-message="errorMessage"
    hint="Choose audio file (.mp3)"
    @file-selected="changeFileHandle"
  ></modern-upload-field>
</template>

<script>
import service from '@/services/index'
import { mapActions } from 'vuex'
import ModernUploadField from '@/components/Forms/ModernUploadField'

const resource = service.resource('races/upload-audio-file')

export default {
  name: 'uploadField',
  components: { ModernUploadField },
  props: {
    label: {
      required: false,
      type: String
    },
    value: {
      required: true
    },
    name: {
      required: true,
      type: String
    },
    errorMessage: {
      required: false,
      type: String
    },
    hasError: {
      required: false
    },
    required: {
      type: Boolean
    }
  },
  data: () => ({
    input: '',
    uploading: false
  }),
  methods: {
    changeFileHandle (e) {
      const originalFile = e.target.files[0]
      if (!originalFile) {
        return
      }

      const file = new FormData()
      file.append('file', originalFile)

      this.addTaskToQueue('saveRaceMedia')
      this.uploading = true
      resource.save(file)
        .then(({ body }) => {
          this.$emit('input', body.url)
          this.$emit('saved', body.url)
          this.removeTaskFromQueue('saveRaceMedia')
        }).finally(() => {
          this.uploading = false
        })
    },
    ...mapActions({
      addTaskToQueue: 'LoadingQueue/addTaskToQueue',
      removeTaskFromQueue: 'LoadingQueue/removeTaskFromQueue'
    })
  }
}
</script>



// WEBPACK FOOTER //
// RaceMedia.vue?7e6534fe